import styled from 'styled-components';

import { IconFormIndicatorWarning } from '@components/icons/form-indicator-warning';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

type AssistantMessageProps = {
  text: string;
  errorMessage?: string;
  errorType?: string;
};

export const AssistantMessage = ({ text, errorMessage, errorType }: AssistantMessageProps) => {
  const isError = Boolean(errorMessage && errorType);

  if (isError) {
    return (
      <ErrorMessageContainer>
        <Stack orientation="horizontal" space={2}>
          <IconFormIndicatorWarning />
          <Text color="elementOrange200" font="regular14" text={text} />
        </Stack>
      </ErrorMessageContainer>
    );
  }

  return (
    <AssistantBorder>
      <AssistantMessageContainer>
        <Text color="textPrimary" font="regular14" text={text} />
      </AssistantMessageContainer>
    </AssistantBorder>
  );
};

const AssistantMessageContainer = styled.div({
  width: '100%',
  borderRadius: pxToRem(7),
  padding: pxToRem(12),
  background: theme.color.backgroundLightDark,
});

const ErrorMessageContainer = styled.div({
  width: '100%',
  borderRadius: pxToRem(7),
  padding: pxToRem(12),
  background: theme.color.orangeTrans10,
});

const AssistantBorder = styled.div({
  width: '100%',
  borderRadius: pxToRem(8),
  padding: pxToRem(1),
  background: 'linear-gradient(112deg, rgba(99, 214, 250, 0.20) 0%, rgba(224, 57, 206, 0.20) 100%)',
});
